export default function (value: string | number, locale = 'en-US') {
  if (Number.isNaN(value)) {
    return value;
  }
  return Number(value).toLocaleString(locale, {
    minimumFractionDigits: 2,
  });
}
